import { Injectable } from "@angular/core"
import { State, Selector, Action, StateContext } from "@ngxs/store"
import { Observable, tap } from "rxjs"
import { UserApiResponse, UserViewModel } from "../../interfaces/viewmodels/userviewmodel"
import { AccountService } from "../../services/account.service"
import { RTAApiClient } from "../../services/rta-api.service"
import { AssignedSubApplications, ReturnViewModel } from "../../interfaces/request.interface"
import { AccountActions } from "../action/account.action"
import { AdminService } from "../../services/admin.service"

export interface AccountStateModel {
    user: UserViewModel,
    users: UserViewModel[]
}

@State<AccountStateModel>({
    name: 'account',
    defaults: {
        user: {} as UserViewModel,
        users: []
    }
})
@Injectable()
export class AccountState {
    constructor(
        private service: AccountService,
        private rtaAPIService: RTAApiClient,
        private adminService: AdminService
    ) { }

    @Selector()
    static user(state: AccountStateModel): UserViewModel {
        return state.user;
    }
    
    @Selector()
    static users(state: AccountStateModel): UserViewModel[] {
        return state.users;
    }

     @Action(AccountActions.GetUserByEmail)
    getAccountbyEmail(
        ctx: StateContext<AccountStateModel>,
        action: AccountActions.GetUserByEmail
      ): Observable<UserViewModel> {
         return this.service.getUserByEmail(action.payload.email);
      }

    @Action(AccountActions.GetUserDetails)
    getAccountDetails(
        ctx: StateContext<AccountStateModel>,
        action: AccountActions.GetUserDetails
      ): Observable<UserViewModel> {

        return this.service.getUserDetails(action.payload.id).pipe(
          tap(user => {
            const currentUser = ctx.getState().user;
            const updatedUser: UserViewModel = {
              ...currentUser,
              ...user,
              Routes: user.permissions.map(p => p.name),
              // Preserve AssignedSubApplications if already loaded
              AssignedSubApplications: currentUser?.AssignedSubApplications ?? user.AssignedSubApplications
            };
            ctx.patchState({ user: updatedUser });
            this.adminService.UserPermissions = user?.permissions ?? [];
            this.adminService.markPermissionsReady();
          })
        );
      }


    @Action(AccountActions.GetAllUserDetails)
    getAllUserDetails(ctx: StateContext<AccountStateModel>, action: AccountActions.GetAllUserDetails): Observable<UserViewModel[]> {
        return this.service.listUsers().pipe(tap(users => { ctx.patchState({ users }) }));
    }

    @Action(AccountActions.GetAssignSubApplications)
    getAssignSubApplications(ctx: StateContext<AccountStateModel>, action: AccountActions.GetAssignSubApplications) {
        return this.rtaAPIService.getAssignedSubApplications(action.payload.userId, action.payload.isActive).pipe(
            tap((subApps: AssignedSubApplications[]) => {
                const state = ctx.getState();
                ctx.patchState({
                    user: {
                        ...state.user,
                        AssignedSubApplications: subApps
                    } as UserViewModel
                });
            })
        );
    }
}
